//Fix issue where, on mobile, if you click a link while not on the top of a page you are directed to the middle of the newly loaded page
//https://stackoverflow.com/questions/36904185/react-router-scroll-to-top-on-every-transition

import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop({ history }) {
  useEffect(() => {
    const unListen = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
        unListen();
    }
  }, [history]);

  return (null);
}

export default withRouter(ScrollToTop);